<template>
  <section id="free-ipnft" class="free-blindbox-section">
    <h2 class="section-title">
      参与盲盒获取
      <span class="highlight">价值NFT</span>
    </h2>
    <div class="card-list">
      <div
        v-for="card in cards"
        :key="card.id"
        class="blind-card"
        @click="$emit('card-click', card)"
      >
        <div class="card-image">
          <img :src="card.image" :alt="card.name" />
        </div>
        <div class="card-info">
          <p class="card-name">{{ card.name }}</p>
          <div>
            <div class="info-row">
              <span class="label">价格：</span>
              <span class="value">{{ card.price }}RAD</span>
            </div>
            <div class="info-row">
              <span class="label">参与人数：</span>
              <span class="value">{{ card.participants }}人</span>
            </div>
            <div class="info-row">
              <span class="label">最近中奖：</span>
              <span class="value">{{ card.latestWinner }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.free-blindbox-section {
  padding: 50px 30px 30px;
}

.section-title {
  margin: 30px 0 30px;
  font-size: 50px;
  font-weight: normal;
  line-height: 1.3;
  color: #fff;

  .highlight {
    color: #7338ff;
  }
}

.card-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.blind-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border-radius: 34px;
  background: rgba(243, 75, 255, 0.1);
  border-radius: 6px 6px 6px 6px;
  border: 0.5px solid rgba(#f34bff, 0.7);
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: rgba(115, 56, 255, 0.7);
  }
}

.card-image {
  flex-shrink: 0;
  width: 164px;
  height: 248px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.card-info {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 248px;
}

.card-name {
  margin: 0 0 16px;
  font-size: 32px;
  color: #fff;
}

.info-row {
  margin-bottom: 4px;
  font-size: 24px;
  color: #C0C0C0;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
